// modules/estrategias/migrante/api/MigranteAPI.js
import axiosClient from "../../../inicio/api/axiosClient";

export const getPersonas = (params) => axiosClient.get("/migrante", { params });
export const getPersonaById = (id) => axiosClient.get(`/migrante/${id}`);
export const createPersona = (data) => axiosClient.post("/migrante", data);
export const updatePersona = (id, data) => axiosClient.put(`/migrante/${id}`, data);
export const deletePersona = (id) => axiosClient.delete(`/migrante/${id}`);
export const exportarExcelMigrante = (params) => axiosClient.get("/migrante/exportar", { params, responseType: "blob" });

export const subirConsentimientoMigrante = (id, archivo) => {
  const formData = new FormData();
  formData.append("archivo", archivo);
  return axiosClient.post(`/migrante/${id}/consentimiento`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
export const eliminarConsentimientoMigrante = (id) => axiosClient.delete(`/migrante/${id}/consentimiento`);

// Alias usados por offline/migranteOffline.js
export const crearPersonaAPI = createPersona;
export const actualizarPersonaAPI = updatePersona;
